module.exports = __webpack_public_path__ + "assets/img/minus.8e906abd.svg";